import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { authChecking, isAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  if (authChecking) {
    return (
      <div className="loading-page">
        <div className="loading-mark">K</div>
        <p>Checking your Kite session...</p>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/real/login" replace state={{ from: location.pathname }} />;
}
